import { useQuery } from '@tanstack/react-query';
import type { ResourceCategory, WebResource } from '@/content/resources';
import {
  catalogQueryKey,
  mapCatalogItems,
  type CloudCatalogItem,
} from '@/lib/learner-catalog';
import { learnerApiJson } from '@/lib/learner-api';

export function useLearnerCatalog(
  endpoint: string,
  mode: string,
  language: string,
  category: ResourceCategory,
  routeBase: string,
) {
  return useQuery({
    queryKey: catalogQueryKey(endpoint, mode, language),
    queryFn: async () => {
      const items = await learnerApiJson<CloudCatalogItem[]>(
        null,
        `${endpoint}?mode=${encodeURIComponent(mode)}`,
      );
      return mapCatalogItems(items, category, routeBase, language);
    },
    staleTime: 5 * 60_000,
    retry: 1,
  });
}

export function useCatalogResource(
  endpoint: string,
  mode: string,
  language: string,
  category: ResourceCategory,
  routeBase: string,
  slug: string,
): WebResource | undefined {
  const catalog = useLearnerCatalog(endpoint, mode, language, category, routeBase);
  return catalog.data?.find((item) => item.slug === slug);
}
